export const ABOVE_STICKY_HEADER_Z_INDEX = 1100;

export const POPOVER_Z_INDEX = 1060;
